import React from 'react'
import { Form } from "react-bootstrap"
import Col from "react-bootstrap/Col"

const FileField = ({fieldClass, labelClass, type, name, value, required, placeholder, handlechange, accept, label, grpmd, id, filename, mainClass, multiple, files, removeFile }) => (
    <Form.Group as={Col} md={grpmd} controlId={"validation" + name+id} className={"form-wrap "+mainClass}>
        { label
            ? <Form.Label htmlFor='' className={labelClass+ ""}>{label}{required ? '*' : ''}</Form.Label>
            : ''
        }
        <div className={fieldClass}>
            <Form.Control
                required={required}
                type={type}
                name={name}
                value={value}
                onChange={handlechange}
                accept={accept}
                id={id}
                multiple={multiple}
                className="d-none"
            />
            <label htmlFor={id} className="custom-file-label mb-0">{filename ? filename : placeholder}</label>
        </div>
        <div className='row mt-3'>
            {files.map((file, i) => 
                <div className="col-lg-3 col-6" key={file.name}>
                    <div className='card position-relative'>
                        <div className='card-header d-flex flex-row justify-content-bewteen'>
                            <div className='card-title mb-0'>{file.name}</div>
                        </div>
                    <i className='icon-close file-icon-close' onClick={() => removeFile(file)}/>
                    </div>
                </div>
            )}
        </div>
    </Form.Group>
);

export default FileField;